/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Select, SelectOption } from 'sarsaparilla';

const TRAILHEAD_PROP_PATH = 'entrance';

export default class TrailHeadSelector extends React.Component {
    constructor(props) {
        super(props);

        this.changeTrailhead = this.changeTrailhead.bind(this);
    }

    changeTrailhead(event) {
        this.props.pActions.updatePendingReservation(
            this.props.reservation.id,
            TRAILHEAD_PROP_PATH,
            event.target.value
        );
    }

    render() {
        const { reservation, permit, addToInputRefs, vIndex } = this.props;
        const { entrance } = reservation;

        const dropdownOptions = permit.entrances.map((entry) => (
            <SelectOption key={entry.id} value={entry.name}>
                {entry.name}
            </SelectOption>
        ));

        return (
            <div className="permit-vehicle-wrap">
                <div className="rec-nested-wrap">
                    <div className="rec-grid-12-12">
                        <div className="form-section-header">Trailhead Locations</div>
                        <p>
                            Select the starting trailhead location you will be using
                            during your trip.
                        </p>
                    </div>
                    <div className="rec-grid-12-12">
                        <div className="rec-nested-wrap">
                            <div className="rec-grid-4-12">
                                <Select
                                    id="dropdown-vehicle-type"
                                    label="Starting Trailhead"
                                    placeholder="Select a starting trailhead"
                                    ref={addToInputRefs(vIndex + 22)}
                                    value={entrance}
                                    isRequired
                                    onChange={this.changeTrailhead}
                                >
                                    {dropdownOptions}
                                </Select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

TrailHeadSelector.propTypes = {
    reservation: PropTypes.object.isRequired,
    validation: PropTypes.object.isRequired,
    displayValidationError: PropTypes.bool,
};
